import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../Styles/styles.css';

const Contacts = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');

       // Validation function
       const validateForm = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Invalid email format';
        }
        if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
        if (!formData.message.trim() || formData.message.length < 10) {
            newErrors.message = 'Message must be at least 10 characters';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
          e.preventDefault();
        if (!validateForm()) return;

        setIsLoading(true);
        setStatusMessage(''); // Reset the status message

        try {
            // Send the email via EmailJS
            const response = await emailjs.send(
                'service_fkz8fad',        // Service ID (from EmailJS dashboard)
                'template_9eg9o27',       // Template ID (from EmailJS dashboard)
                formData,                 // Form data to pass
                'AHLq32ZUFpwypILMz'       // User ID (from EmailJS dashboard)
            );

            console.log('Email sent successfully:', response);
            setStatusMessage('Your message has been sent. Thank you!');
            setFormData({ name: '', email: '', subject: '', message: '' }); // Reset the form
            setErrors({});
        } catch (error) {
            console.error('Error sending email:', error);
            setStatusMessage('Failed to send message. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section id="contact" className="contact section-bg">
            <div className="container" data-aos="fade-up">

                <div className="section-title">
                    <h2>Contact</h2>
                </div>

                <div className="row">
                    <div className="col-lg-5 d-flex align-items-stretch">
                        <div className="info">
                            <div className="address">
                                <i className="bi bi-geo-alt"></i>
                                <h4>Location:</h4>
                                <p>
                                    #736, 7th Main, 1st Floor,
                                    Mahalaxmi Layout,
                                    Bengaluru-560086,
                                    Karnataka, India
                                </p>
                            </div>

                            <div className="email">
                                <i className="bi bi-envelope"></i>
                                <h4>Email:</h4>
                                <p>info@mmcspl.com</p>
                            </div>

                            <div className="phone">
                                <i className="bi bi-phone"></i>
                                <h4>Call:</h4>
                                <p>+91 (80) 2349 2185</p>
                            </div>

                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d971.8488142106597!2d77.54295556950993!3d13.010483105884322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bae3d75f2346207%3A0x6e08c90debb229ab!2s736%2C%207th%20Main%20Rd%2C%20Mahalakshmipuram%20Layout%2C%20Mahalakshmi%20Layout%2C%20Bengaluru%2C%20Karnataka%20560086!3m2!1d13.010481799999999!2d77.5435993!5e0!3m2!1sen!2sin!4v1741953948744!5m2!1sen!2sin"
                                frameBorder="0"
                                style={{ border: '0', width: '100%', height: '290px' }}
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>

                    <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                        <form onSubmit={handleSubmit} className="php-email-form">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="name">Your Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.name && <small className="error-text">{errors.name}</small>}
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="email">Your Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                     {errors.email && <small className="error-text">{errors.email}</small>}
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="subject">Subject</label>
                                <input
                                    type="text"
                                    name="subject"
                                    className="form-control"
                                    id="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.subject && <small className="error-text">{errors.subject}</small>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    className="form-control"
                                    name="message"
                                    rows="10"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                                {errors.message && <small className="error-text">{errors.message}</small>}
                            </div>
                            <div className="my-3">
                                {isLoading && <div className="loading">Loading...</div>}
                                {statusMessage && <div className="sent-message">{statusMessage}</div>}
                            </div>
                            <div className="text-center">
                                <button type="submit" disabled={isLoading}>
                                    {isLoading ? 'Sending...' : 'Send Message'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contacts;
